import PasswordToggle from './toggle-password'

export default PasswordToggle
